import { Component, OnInit } from '@angular/core';
import { BaseDatasourceComponent } from '../base-datasource/base-datasource.component';
import { CommonService, Currency, CurrencyService, Shared, TIMEZONES } from '@rubii/frontend-common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfigService } from '../../../services/config.service';
import { DatasourceConnectionComponent } from '../../datasource-connection/datasource-connection.component';
import { ClientService } from '../../../services/client.service';

@Component({
  selector: 'app-lifesight',
  templateUrl: './lifesight.component.html',
  styleUrls: ['./lifesight.component.scss']
})
export class LifesightComponent extends BaseDatasourceComponent implements OnInit {

  currencies: Currency[] = [];
  timezones: string[] = [];

  constructor(
    private client: ClientService, private currencySvc: CurrencyService, private config: ConfigService, private snackBar: MatSnackBar, private dialogRef: MatDialogRef<DatasourceConnectionComponent>) {
    super();
  }

  async ngOnInit() {
    this.connectionForm = new FormGroup({
      email: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required]),
      currency: new FormControl('AUD', [Validators.required]),
      timezone: new FormControl('UTC', [Validators.required]),
    });

    this.currencies = await this.currencySvc.getCurrencies();
    this.timezones = TIMEZONES;
  }

  connect() {
    if (this.connectionForm.valid) {
      this.client.account.saveLifesightConfig(this.connectionForm.value).then(result => {
        this.openSnackBar(this.snackBar, 'Data source connected.', 'closed');
          this.dialogRef.close();
      }).catch(e => this.openSnackBarWarning(this.snackBar, e.message, 'closed'));
    }
  }
}
